import thunk from 'redux-thunk';
import apiFailureMiddleware from './apiFailure';

// apiFailureMiddleware must come before the thunk.

const middlewares = [apiFailureMiddleware, thunk];

export default middlewares;
